import DropzoneCintainer from "../../Componant/BonusUI/Dropzone";

const Dropzone = () => {
  return (
    <div className="page-body">
      <DropzoneCintainer />
    </div>
  );
};

export default Dropzone;
